module.exports = __webpack_public_path__ + "media/images/weo-tv-lg-4ead34845514019a967794357bf688da.png";